<template>
  <div>
    <vue3-chart-js
      :id="barChart.id"
      ref="barRef"
      :type="barChart.type"
      :data="barChart.data"
      :options="barChart.options"
    >
    </vue3-chart-js>
  </div>
</template>

<script>
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import useGlobalHelpers from '@/mixins/useGlobalHelpers.js'

export default {
  name: 'App',
  components: {
    Vue3ChartJs,
  },
  props: {
    timeView: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const i18n = useI18n({ useScope: 'global' })
    const { dollarFormatting } = useGlobalHelpers()

    const barRef = ref(true)
    const barChart = ref({
      id: 'bar',
      type: 'bar',
      data: {
        labels: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'], // how many bars are gonna show on the chart
        datasets: props.timeView,
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            callbacks: {
              title: function (tooltipItem) {
                return i18n.t(tooltipItem[0].dataset.title)
              },
              label: function (context) {
                return '$' + dollarFormatting(parseFloat(context.raw) * 100) || ''
              },
              labelColor: function (context) {
                return {
                  borderColor: context.dataset.backgroundColor,
                  backgroundColor: context.dataset.backgroundColor,
                  borderWidth: 2,
                  borderRadius: 2,
                }
              },
            },
          },
        },
        responsive: true,
        barThickness: 10,
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false,
            },
            ticks: {
              color: '#a3a8ad',
              font: {
                size: 10,
              },
            },
          },
          y: {
            stacked: true,
            grid: {
              color: 'rgba(230, 230, 230, 0.49)',
              drawBorder: false,
            },
            ticks: {
              color: '#a3a8ad',
              font: {
                size: 10,
                weight: 400,
              },
              callback: function (label) {
                if (label > 1000) return `$${label / 1000}k`
                return `$${label}`
              },
            },
          },
        },
      },
    })

    watch(
      () => props.timeView,
      (newValue) => {
        if (newValue.length > 0) {
          barChart.value.data.datasets = newValue
          barRef.value.update(250)
        }
      }
    )

    return {
      barChart,
      barRef,
    }
  },
}
</script>
